<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-10 14:38:51
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-21 14:53:43
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/applyInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <el-form
      :model="applyInfoForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="申请人:" prop="applicant">
            <el-input
              v-model="applyInfoForm.applicant"
              placeholder="请输入申请人"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电话号码:" prop="mobile">
            <el-input
              v-model="applyInfoForm.mobile"
              placeholder="请输入电话号码"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邮箱:" prop="email">
            <el-input
              v-model="applyInfoForm.email"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位地址:" prop="address">
            <el-input
              v-model="applyInfoForm.address"
              placeholder="请输入单位地址"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="生产地址:"
            prop="factory"
            style="margin-bottom:0 ;"
          >
            <el-input
              type="textarea"
              maxlength="500"
              v-model="applyInfoForm.factory"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    applyInfoForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let emailReg = /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    const email = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback('请输入邮箱');
        return;
      }
      if (!emailReg.test(value)) {
        callback(new Error('请输入正确的邮箱地址'));
      } else {
        callback();
      }
    };
    const mobileReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;

    const isPhone = /^(0|4)\d{2,3}-?\d{7,8}$/;
    const mobilePhone = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('请输入手机号或固定电话'));
      } else if (!isPhone.test(value) && !mobileReg.test(value)) {
        callback(new Error('请输入正确的手机号或固定电话'));
      } else {
        callback();
      }
    };
    return {
      // ruleForm: this.applyInfoForm,
      rules: {
        applicant: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            min: 1,
            max: 100,
            message: '长度在 1 到 100 个字符',
            trigger: 'blur'
          }
        ],

        mobile: [
          {
            required: true,
            validator: mobilePhone,
            trigger: 'blur'
          }
        ],
        email: [
          {
            validator: email,
            trigger: 'blur',
            required: true
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ],
        address: [{ required: true, message: '请输入', trigger: 'blur' }],
        factory: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            min: 1,
            max: 500,
            message: '长度在 1 到 500 个字符',
            trigger: 'blur'
          }
        ]
      }
    };
  },

  components: {},

  computed: {},

  created() {
    // this.ruleForm = this.applyInfoForm;
  },
  mounted() {
    console.log(this.applyInfoForm);
  },
  methods: {
    submitForm(callback) {
      let result = null;
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          result = true;
          callback(result);
        } else {
          console.log('error submit!!');
          result = false;
          callback(result);
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
